<template>
	<div class="btnLinkWrap">
		<template v-if="link">
			<a class="btnLink" :class="[size]" :href="link" :target="target" :title="title">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 41"><path :style="'fill:'+color" d="M22.149,41,0,20.5,22.15,0,37.663,14.358H27.03L22.15,9.841,10.633,20.5,22.15,31.16l4.88-4.516H37.663L22.152,41l0,0Zm19.216-9.418,8.9-8.1H21.764V17.518h28.5l-8.9-8.1,4.223-3.841L62,20.5,45.588,35.42Z" fill="#7a7a7a"/></svg>
			</a>
		</template>
		<template v-else-if="routerLink">
			<router-link class="btnLink" :class="[size]" :to="routerLink">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 41"><path :style="'fill:'+color" d="M22.149,41,0,20.5,22.15,0,37.663,14.358H27.03L22.15,9.841,10.633,20.5,22.15,31.16l4.88-4.516H37.663L22.152,41l0,0Zm19.216-9.418,8.9-8.1H21.764V17.518h28.5l-8.9-8.1,4.223-3.841L62,20.5,45.588,35.42Z" fill="#7a7a7a"/></svg>
			</router-link>
		</template>
		<template v-else>
			<a @click="portfolioPopupOpen" class="btnLink noLink" :class="[size]">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 41"><path :style="'fill:'+color" d="M22.149,41,0,20.5,22.15,0,37.663,14.358H27.03L22.15,9.841,10.633,20.5,22.15,31.16l4.88-4.516H37.663L22.152,41l0,0Zm19.216-9.418,8.9-8.1H21.764V17.518h28.5l-8.9-8.1,4.223-3.841L62,20.5,45.588,35.42Z" fill="#7a7a7a"/></svg>
			</a>
		</template>
	</div>
</template>

<script>
import { EventBus } from '../utils/event-bus'

export default {
	name: 'ButtonLinkPage',
	props: {
		link: String,
		portfolioPopup: {
			type: Boolean,
			default: false
		},
		target: {
			type: String,
			default: '_self'
		},
		title: {
			type: String,
			default: ''
		},
		color: {
			type: String,
			default: '#7A7A7A'
		},
		routerLink: {
			type: String,
			default: ''
		},
		size: {
			type: String,
			default: ''
		},
		linkData: {
			type: Object,
			default: function () {
				return {
					index: 0,
					data: {}
				}
			}
		}
	},
	methods: {
		portfolioPopupOpen () {
			if (this.portfolioPopupOpen) {
				EventBus.$emit('portfolio-popup-open', this.linkData)
			} else {
				console.log('No 링크')
			}
		}
	}
}
</script>
<style lang="scss">
	.btnLinkWrap {
		position: relative;
	}
</style>
<style scoped lang="scss">
	svg {fill:#7a7a7a;}
	a,
	.noLink {
		position: absolute;
		width: 100%;
		height: 100%;
		display: block;
		padding: 20px;
		opacity: 0.8;
		transition: 0.4s opacity;
	}
	a:hover {
		opacity: 1;
	}
	svg {
		position: absolute;
		top: 50%; left: 50%;
		transform: translate(-50%, -50%);
		width:62px; height: 41px;

	}
	.btnLinkWrap {
		width: 54px;
		height: 54px;
		svg {height: 50%; width: auto;}
		.is-tiny {
			transform: scale(0.5);
		}
		.is-small {
			transform: scale(0.75);
		}
		.is-medium {
			transform: scale(1);
		}
		.is-large {
			transform: scale(1.25);
		}
	}
</style>
